import { AppConstants } from './../constants/app-constants';
import { IDBService } from './indexdb/idb.service';
import { Injectable } from '@angular/core';
import { LoggingService } from './logging/logging.service';
import { LoggingConstants } from './../constants/logging-constant';
import { DomStorageFallbackService } from './DomStorageFallback.service';
import { AppUtility } from './../utils/utility';

@Injectable()
export class AppStartupService {
    private static dbInitialized: boolean = false;
    private GatewayURL: string = '';

    /* istanbul ignore next */
    constructor(private idbService: IDBService, private loggingService: LoggingService, private domStorageFB: DomStorageFallbackService, private appUtility: AppUtility) {
        try {
            this.GatewayURL = this.domStorageFB.getItem('gatewayUrl');
        } catch (error) {
            this.loggingService._debug('AppStartupService() : Could not find gateway URL.' + error, 'UI Core', LoggingConstants.INFO);
            this.GatewayURL = null;
        }

        let app_url = './';
        try {
            app_url = this.domStorageFB.getItem('app_url');
            if (app_url === null) {
                app_url = './';
            }
        } catch (error) {
            this.loggingService._debug('AppStartupService() : Could not find app URL.' + error, 'UI Core', LoggingConstants.INFO);
        }

        // UFD-1558, UFD-2146
        try {
            let c = this.appUtility.getSWConfiguration();
            this.appUtility.saveSWConfInStorage(JSON.stringify(c));
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('AppStartupService| constructor() service worker configuration - Error ', error);
            }
        }
    }

    /* istanbul ignore next */
    public initDB(componentList: any) {
        if (LoggingService.uConsole) {
            console.log('In AppStartupService.initDB() componentList ', componentList);
        }
        if (LoggingService.uConsole) {
            console.log('In AppStartupService.initDB()');
        }
        if (AppStartupService.dbInitialized) {
            return;
        }
        // Getting all stores list for IndexedDB , all required stores are created at bootstrap time.
        componentList.forEach(element => {
            if (element.store) {
                let storeList = (element.store).split(',');
                storeList.forEach(nElement => {
                    if (LoggingService.uConsole) {
                        console.log('store is ::', nElement);
                    }
                    this.idbService.idbStoreList.push(nElement);
                });
            }

        }); // assign the data from subscription to your class variable

        if (LoggingService.uConsole) {
            console.log('storeList final at completion ', this.idbService.idbStoreList);
        }

        /*DB init : Promise 1 */
        let initDB = this.idbService.openDB(AppConstants.APP_DB_NAME, AppConstants.APP_INIT_TABLE)
            .toPromise();

        /**config file resolve  : Promise 2*/
        try {
            this.GatewayURL = this.domStorageFB.getItem('gatewayUrl');
        } catch (error) {
            this.loggingService._debug('AppStartupService() : Could not find gateway URL.' + error, 'UI Core', LoggingConstants.INFO);
            this.GatewayURL = null;
        }

        let app_url = './';
        try {
            app_url = this.domStorageFB.getItem('app_url');
            if (app_url === null) {
                app_url = './';
            }
        } catch (error) {
            this.loggingService._debug('AppStartupService() : Could not find app URL.' + error, 'UI Core', LoggingConstants.INFO);
        }


        if (this.GatewayURL === null) {

            /* config file resolve */
            return Promise.all([initDB]).then((x) => {

                AppStartupService.dbInitialized = true;
                if (LoggingService.uConsole) {
                    console.log('In AppStartupService.initDB() db initalized successfully in if block');
                }
            });
        } else {
            return initDB.then(() => {
                AppStartupService.dbInitialized = true;
                if (LoggingService.uConsole) {
                    console.log('In AppStartupService.initDB() db initalized successfully in else block');
                }
            });
        }
    }

    /* istanbul ignore next */
    public isDBInitialized() {
        if (LoggingService.uConsole) {
            console.log('In AppStartupService.isDBInitialized()', AppStartupService.dbInitialized);
        }
        return AppStartupService.dbInitialized;
    }

    /* istanbul ignore next */
    public gateWayURL(): string {
        return this.GatewayURL;
    }

}
